export enum WorkOrderTemplates {
  ContractorEmail = 99,
  LandlordEmail = 303,
  TenantEmail = 304,
  ContractorSMS = 122,
  LandlordSMS = 123,
  TenantSMS = 124,
}
